var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


//////////////////
// WEBPACK FOOTER
// /Users/mundofr/GitHub/Angle/ChipinqueTrails/~/core-js/modules/_shared.js
// module id = ../../../../core-js/modules/_shared.js
// module chunks = 0